exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".font-family-menu-item-span-1IBGt{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// Exports
exports.locals = {
	"item-span": "font-family-menu-item-span-1IBGt"
};